import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import InlineLoading from "./UI/inlineLoader";
import useGAEventsTracker from "../helpers/useGAEventsTracker";
import { loader } from "../store/actions/loader";
import { addToCart, setTotalPrice } from "../store/actions/shop";

// ── Quantity Selector ─────────────────────────────────────────────────────────
function QuantitySelector({ quantity, inCart, onDecrease, onIncrease, onDelete }) {
  return (
    <section>
      <div className="d-flex align-items-center qty-wrapper justify-content-center " >
      <button
        type="button"
        onClick={inCart ? onDelete : onDecrease}
        className="qty-btn"
        title={inCart ? "Remove from cart" : "Decrease quantity"}
      >
        {inCart ? (
          <i className="fa fa-trash" style={{ color: "#DC042A", fontSize: "12px" }} />
        ) : (
          <span className="qty">−</span>
        )}
      </button>

      <span style={{ minWidth: "24px", textAlign: "center", fontWeight: "600", fontSize: "16px" }}>
        {quantity}
      </span>

      <button
        type="button"
        onClick={onIncrease}
        className="qty-btn"
        title="Increase quantity"
      >
        <span className="qty">+</span>
      </button>
    </div>
    </section>
  );
}

// ── ProductCard ───────────────────────────────────────────────────────────────
const ProductCard = ({ item }) => {
  const GAEventsTracker = useGAEventsTracker("Menu Page");
  const dispatch = useDispatch();

  const allCart = useSelector((state) => state.shop.cart);
  const [productCart, setProductCart] = useState(allCart);
  const [quantity, setQuantity] = useState(1);
  const [inlineLoading, setInlineLoading] = useState(false);

  const prod = {
    id: item.product_id,
    product: item.name,
    product_type: item.type || "simple",
    price: item.price,
    sale_price: item.sale_price ?? null,
    image_url: item.image,
  };

 // get live quantity from cart
const inCart = allCart.some((item) => item.product?.id === item.product_id);
const cartIndex = allCart.findIndex((item) => item.product?.id === item.product_id);

const cartItem = allCart[cartIndex];
const displayQuantity = inCart ? cartItem?.quantity ?? quantity : quantity;

const handleDecrease = () => {
  if (inCart) {
    if (displayQuantity <= 1) {
      deleteFromCartHandler();
      return;
    }
    const cartCopy = [...allCart];
    const price = cartCopy[cartIndex].salePrice || cartCopy[cartIndex].price;
    cartCopy[cartIndex] = {
      ...cartCopy[cartIndex],
      quantity: displayQuantity - 1,
      totalPrice: (displayQuantity - 1) * price,
    };
    setProductCart(cartCopy);
    dispatch(addToCart(cartCopy));
    dispatch(setTotalPrice());
    return;
  }
  setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
};

const handleIncrease = () => {
  if (inCart) {
    const cartCopy = [...allCart];
    const price = cartCopy[cartIndex].salePrice || cartCopy[cartIndex].price;
    cartCopy[cartIndex] = {
      ...cartCopy[cartIndex],
      quantity: displayQuantity + 1,
      totalPrice: (displayQuantity + 1) * price,
    };
    setProductCart(cartCopy);
    dispatch(addToCart(cartCopy));
    dispatch(setTotalPrice());
    return;
  }
  setQuantity((prev) => prev + 1);
};

  const addtoCartHandler = () => {
    GAEventsTracker("Added to cart", `Product Name: ${item.name}`);
    setInlineLoading(true);
    dispatch(loader());

    const prevCart = [...allCart];
    const prodInCartIndex = prevCart.findIndex((cart) => cart.product?.id === item.product_id);

    if (prodInCartIndex >= 0) {
      const prodInCart = prevCart[prodInCartIndex];
      const newTotalPrice = item.sale_price
        ? quantity * parseInt(item.sale_price)
        : quantity * parseInt(item.price);
      prevCart[prodInCartIndex] = {
        product: prod,
        quantity: prodInCart.quantity + quantity,
        price: parseInt(item.price),
        salePrice: item.sale_price ? parseInt(item.sale_price) : null,
        totalPrice: prodInCart.totalPrice + newTotalPrice,
      };
    } else {
      prevCart.push({
        product: prod,
        quantity,
        price: parseInt(item.price),
        salePrice: item.sale_price ? parseInt(item.sale_price) : null,
        totalPrice: item.sale_price
          ? quantity * parseInt(item.sale_price)
          : quantity * parseInt(item.price),
      });
    }

    setProductCart(prevCart);
    dispatch(addToCart(prevCart));
    dispatch(setTotalPrice());

    setTimeout(() => { dispatch(loader()); }, 1500);
    setTimeout(() => { setInlineLoading(false); }, 1500);
    setTimeout(() => { NotificationManager.success("Added to cart successfully", "", 3000); }, 1500);
  };

  const deleteFromCartHandler = () => {
    const cartSlice = [...allCart];
    cartSlice.splice(cartIndex, 1);
    setProductCart(cartSlice);
    dispatch(addToCart(cartSlice));
    dispatch(setTotalPrice());
  };

  const isUnavailable = item.in_stock === false;

  return (
    <div className="row mb-5 text-center text-md-left">

      {/* Image */}
      <div className="col-md-4 mb-5 mb-md-5 d-flex justify-content-center justify-content-md-start">
        <img
          className="img-fluid"
          src={item.image}
          alt={item.name}
          width="200px"
          height="200px"
          style={{borderRadius: "5px"}}
        />
      </div>

      {/* Details */}
      <div className="col-md-8">

        {/* Row 1: Product name + quantity selector */}
        <div className="d-flex align-items-center justify-content-between   mb-5">
          <p className="product-name mb-0 w-100 text-center text-md-left">{item.name}</p>
           {/* <div className="d-flex justify-content-center justify-content-md-start w-100 mt-2 mt-md-0"></div> */}
            <QuantitySelector
            quantity={displayQuantity}
            inCart={inCart}
            onDecrease={handleDecrease}
            onIncrease={handleIncrease}
            onDelete={deleteFromCartHandler}
          />
           
          
        </div>

        {/* Row 2: Price + Add to Cart button */}
       <div className="d-flex flex-column flex-md-row align-items-center justify-content-between mt-4">
  <p className="mb-2 mb-md-0 w-100 text-center text-md-left" style={{ fontWeight: "700", fontSize: "15px" }}>
    ₦{Number(item.price).toLocaleString()}
  </p>
  <div className="d-flex justify-content-center justify-content-md-start w-100 mt-2 mt-md-0 text-nowrap">
    {isUnavailable ? (
      <button className="btn w-100" disabled style={{ opacity: 0.6, cursor: "not-allowed" }}>
        <span className="text ">Out of Stock</span>
      </button>
    ) : inlineLoading ? (
      <InlineLoading />
    ) : inCart ? (
      <span style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        color: "#E1686D",
        fontWeight: "600",
        fontSize: "14px",
      }}>
        <span style={{ fontSize: "20px" }}>✓</span> Added to Cart
      </span>
    ) : (
      <button className="btn w-100" onClick={addtoCartHandler}>
        <span className="text">Add to Cart</span>
      </button>
    )}
  </div>
</div>

      </div>
    </div>
  );
};

export default ProductCard;